import clsx from "clsx";

import { usePageTitle } from "@/atoms/page-title-atom";
import { VideoToolTip } from "@components/video-tooltip";
import { useFeatureFlags } from "@hooks/http";

export type NavbarTitleProps = { className?: string };

/* TODO: Replace the contents of this component with portal targets, such that the individual pages
   themselves can more explicitly define the title text and tooltips that should be present, without
   having to use wonky state behavior. */
export const NavbarTitle = (props: NavbarTitleProps) => {
  const [pageTitle] = usePageTitle();
  const { hasFeatureFlag } = useFeatureFlags();

  return (
    <div
      {...props}
      className={clsx("flex flex-row items-center gap-1", props.className)}
    >
      <div className="text-lg">{pageTitle}</div>
      {pageTitle === "Sales" && (
        <VideoToolTip
          videoUrl="https://www.youtube.com/embed/uJMocV_YttE?si=24pbyjBleHNSANTE"
          contentDetails={{
            title: "Sales page overview",
            content:
              "The Northbeam Sales page allows for faster and more detailed analysis " +
              "of your marketing performance.",
            kbLink: "https://docs.northbeam.io/docs/sales-page",
          }}
        />
      )}
      {hasFeatureFlag("overviewPageV2") && pageTitle === "Overview" && (
        <VideoToolTip
          videoUrl="https://www.youtube.com/embed/CRiRcXlnNVM?si=24pbyjBleHNSANTE"
          contentDetails={{
            title: "Overview page",
            content:
              "Drag, drop and save the metrics that matter most to you. Create saved " +
              "views for even faster analysis.",
            kbLink: "https://docs.northbeam.io/docs/overview-page",
          }}
        />
      )}
      {pageTitle === "Manage breakdowns" && (
        <VideoToolTip
          videoUrl="https://www.youtube.com/embed/eKzVi8wWE3E?si=24pbyjBleHNSANTE"
          contentDetails={{
            title: "Breakdowns page",
            content:
              "Drag, drop and save the metrics that matter most to you. Create saved " +
              "views for even faster analysis.",
            kbLink: "https://docs.northbeam.io/docs/saved-views-and-breakdowns",
          }}
        />
      )}
    </div>
  );
};
